export const MODAL_SCROLLABLE_PADDING_MOBILE = '40px 0 16px';
export const MODAL_SCROLLABLE_PADDING_DESKTOP = '40px 0 32px';
export const MODAL_PADDING_MOBILE = '32px 16px 16px';
export const MODAL_PADDING_DESKTOP = '32px';
export const WINNERS_MODAL_PADDING = '40px 0 5px';
